import React, { useState, useEffect, useContext } from "react";
import { Row, Col, Button, OverlayTrigger, Popover } from "react-bootstrap";
import CustomFormCheck from "utils/CustomFormCheck";
import CustomTooltip from "utils/CustomTooltip";
import BackButton from "../BackButton";
import NextButton from "../NextButton";
import SkipButton from "../SkipButton";
import getNextPage from "../getNextPage";
import { RouterContext } from "../Onboarding";

export default function GoogleSearchConsoleAccess(props) {
  const route = useContext(RouterContext);

  let tipImage = require("images/onboarding/domain.png");
  tipImage = <img className="" src={`/datapulse${tipImage}`} />;

  const nextPage = getNextPage(props.onboarding_progress);
  const [userGrantAccess, setUserGrantAccess] = useState(
    props.teamAccess["Google Search Console"]["Full"] == "1" || props.teamAccess["Google Search Console"]["Restricted"] == "1"
  );
  useEffect(() => {
    window.localStorage.setItem("routerHistory", JSON.stringify([...route.get]));
  }, [route.get]);

  props.pageLocator();

  const [validated, setValidated] = useState(false);

  useEffect(() => {
    const form = document.getElementById("onboarding-form");
    if ((form.checkValidity() === true) && ((props.teamAccess["Google Search Console"]["Restricted"] === "1") || (props.teamAccess["Google Search Console"]["Full"] === "1")) && props.domainProperty !== undefined) {
      setValidated(true);
    } else {
      setValidated(false);
    }
  });

  const authenticateFunction = (platform) => {
    window.open(platform["auth_url"], '_blank');
  };

  const deauthorizeFunction = (platform) => {
    window.open(platform["deauth_url"], '_blank');
  };

  const resetMessage = (platformName) => {
    return (`Resetting ${capitalize(platformName)} token will require you to authenticate again`)
  }

  const authButton = (platform) => {
    if (platform.authenticated) {
      return (
        <>
          <Button className="mb-4 btn-lg text-center" variant="danger" onClick={() => deauthorizeFunction(platform)}>
            Reset Token
            <CustomTooltip faClass="text-white far fa-question-circle f18 pl-2" message={resetMessage(platform["title"])} inline={true} />
          </Button>
        </>
      )
    } else {
      return (
        <>
          <Button className="mb-4 btn-lg text-center" variant="success" onClick={() => authenticateFunction(platform)}>
            Authenticate
            <i className="fas fa-cog pl-2" style={{paddingRight: "0px", color: "unset", float: "unset"}}></i>
          </Button>
        </>
      )
    }
  }

  return (
    <>
      <Row className=" px-4 mb-3 pb-3 justify-content-center">
        <Col md={7}>
          <div>
            <p className="pb-3 f28 visby-bold primary text-center">Grant Google Search Console Access</p>
          </div>
          <div>
            <p className=" f14 nunito-regular primary ">
              On this page you will grant access to Google Search Console. Please check the box to indicate the access level granted. It's important to note that checking the access level boxes are solely for reference,
              and will not perform any actions in regards to granting access to your account.
            </p>
          </div>
        </Col>
      </Row>
      <Row className="my-5 justify-content-center">
        <Col lg={5}>
          <Row >
            <Col className="mr-0" md={5}>
              <p className="visby-bold pb-2 light-primary f14">Authenticate with Google:</p>
            </Col>
          </Row>
          <Row className="pb-4">
            <Col>
              <div style={{ backgroundColor: "#E1E1E1", paddingRight: "10px", paddingTop: "20px", paddingLeft: "10px"}}>
                <div className="ml-3">
                  {authButton(props.api_platforms["google_webmasters"])}
                  <p className="f-14 light-primary pb-3">{props.api_platforms["google_webmasters"]["authenticated"] ?
                  "You have already authenticated with Google Search Console. If you need access to clients on a different account, reset your token and reauthenticate."
                  : "You must go through the authentication process before you can pull data from Google Search Console!"
                  }
                  </p>
                </div>
              </div>
            </Col>
          </Row>
          <div>
            <p className="f14 light-primary">Complete as many of the below steps as possible, and check to confirm.</p>
          </div>
          <div className="p-4" style={{ backgroundColor: "#E1E1E1", marginTop: "14px" }}>
            <div className="pb-2">
              <CustomFormCheck
                required
                id="ob_google_search_console_granted"
                name="ob_google_search_console_granted"
                label="Google Search Console access granted"
                checked={userGrantAccess}
                onChange={(e) => {
                  let accessChecked = props.teamAccess;
                  accessChecked["Google Search Console"]["Restricted"] = "0";
                  accessChecked["Google Search Console"]["Full"] = "0";
                  setUserGrantAccess(!userGrantAccess);
                  props.setTeamAccess({ ...accessChecked });
                }}
              />
            </div>
            <div>
              <p className="pl-3 pb-1 f16 primary">Please indicate access granted.</p>
            </div>

            <div className="pb-1 pl-3">
              <CustomFormCheck
                id="ob_google_search_console_full"
                name="google_search_console_granted_full"
                label="Full"
                disabled={!userGrantAccess}
                checked={props.teamAccess["Google Search Console"]["Full"] == "1"}
                onChange={(e) => {
                  let accessChecked = props.teamAccess;
                  accessChecked["Google Search Console"]["Restricted"] = "0";
                  accessChecked["Google Search Console"]["Full"] = props.teamAccess["Google Search Console"]["Full"] == "1" ? "0" : "1";
                  props.setTeamAccess({ ...accessChecked });
                }}
              />
            </div>
            <div className="pb-1 pl-3">
              <CustomFormCheck
                id="ob_google_search_console_restricted"
                name="google_search_console_granted_restricted"
                label="Restricted"
                disabled={!userGrantAccess}
                checked={props.teamAccess["Google Search Console"]["Restricted"] == "1"}
                onChange={(e) => {
                  let accessChecked = props.teamAccess;
                  accessChecked["Google Search Console"]["Full"] = "0";
                  accessChecked["Google Search Console"]["Restricted"] = props.teamAccess["Google Search Console"]["Restricted"] == "1" ? "0" : "1";
                  props.setTeamAccess({ ...accessChecked });
                }}
              />
            </div>
          <div>
              <span className="pl-3 pb-1 f16 primary">Property is a domain property?</span>  <CustomTooltip faClass="far primary fa-question-circle pt-1 pl-2" message={tipImage} inline={true} />
            </div>
            <div className="pb-2 pl-3">
              <CustomFormCheck
                id="ob_google_search_console_domain_property-yes"
                name="ob_google_search_console_domain_property-yes"
                label="Yes"
                checked={props.domainProperty === true}
                onChange={(e) => {
                  let domainChecked
                  if (props.domainProperty === undefined)
                  {
                    domainChecked = true
                  }
                  if (props.domainProperty === true)
                  {
                    domainChecked = undefined
                  }
                  if (props.domainProperty === false)
                  {
                    domainChecked = true
                  }
                  props.setDomainProperty(domainChecked);
                }}
              />
            </div>
            <div className="pb-2 pl-3">
              <CustomFormCheck
                id="ob_google_search_console_domain_property-no"
                name="ob_google_search_console_domain_property-no"
                label="No"
                checked={props.domainProperty === false}
                onChange={(e) => {
                  let domainChecked
                  if (props.domainProperty === undefined)
                  {
                    domainChecked = false
                  }
                  if (props.domainProperty === true)
                  {
                    domainChecked = false
                  }
                  if (props.domainProperty === false)
                  {
                    domainChecked = undefined
                  }
                  props.setDomainProperty(domainChecked);
                }}
              />
            </div>
          </div>
        </Col>
        {/* <Col className="mt-3" lg={5}>
          <iframe
            width="560"
            height="315"
            src="https://www.youtube.com/embed/aMdyzHq5Pgg"
            title="YouTube video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            style={{ maxWidth: "100%" }}></iframe>
        </Col> */}
      </Row>
      <Row className="justify-content-center">
        <Col>
          <div className="navButtonRow">
            <BackButton />
            <SkipButton btnText={`Skip for now`} nextPage={nextPage.url} />
            <NextButton
              validated={validated}
              btnText={`Next`}
              nextPage={nextPage.url}
              invalidText={`We need more information on this page before you continue.`}
              submitForm={props.submitForm}
            />
          </div>
        </Col>
      </Row>
    </>
  );
}
